export enum DowntimesStatus {
  creation = 'creation',
  transfer = 'transfer',
  cancellation = 'cancellation',
}
